import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";
import "./style.css";
import { useEffect, useState } from "react";
import { GetAllSC_ST_AI_Field } from "../../../Redux/Reducers/Submitter/SC_ST_AI_Field";
import { GetAllSC_ST_AI_Subject } from "../../../Redux/Reducers/Submitter/SC_ST_AI_Subject";
import {
  GetOneSC_NT_AI_ApplicationInformation,
  setSC_NT_AI_ApplicationInformation,
} from "../../../Redux/Reducers/Submitter/SC_NT_AI_ApplicationInformation";
const ApplicationInfo = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [editValue, setEditValue] = useState(null);
  const [editText, setEditText] = useState(null);
  const [cleartopic, setcleartopic] = useState(false);
  const { ApplicationInformationId } = useParams();
  const lang = useSelector((state) => state.languageReducer.Language);
  const ValidationScientificContributionSubmitted = useSelector(
    (state) =>
      state.ValidationScientificContributionSubmitted
        .ValidationScientificContributionSubmitted
  );
  const ValiationList = ValidationScientificContributionSubmitted?.result?.map(
    (ele) => ele.code
  );
  const SC_ST_AI_SubjectList = useSelector(
    (state) => state.SC_ST_AI_Subject.SC_ST_AI_SubjectList
  );
  const SC_ST_AI_FieldList = useSelector(
    (state) => state.SC_ST_AI_Field.SC_ST_AI_FieldList
  );
  const state = useSelector((state) => {
    return {
      SC_NT_AI_ApplicationInformation:
        state.SC_NT_AI_ApplicationInformation.SC_NT_AI_ApplicationInformation,
    };
  });

  const [ApplicationInformationData, SetApplicationInformationData] = useState(
    {}
  );

  const getData = async () => {
    const data = await dispatch(
      GetOneSC_NT_AI_ApplicationInformation({
        applicationInformationId:
          localStorage.getItem("ApplicationInformationId") ||
          ApplicationInformationId,
      })
    );
    if (data.payload) {
      SetApplicationInformationData({ ...data.payload });
    }
  };
  useEffect(() => {
    getData();
  }, [ApplicationInformationId]);

  useEffect(() => {
    dispatch(GetAllSC_ST_AI_Field({ isEn: lang !== "ar" }));
    dispatch(
      GetAllSC_ST_AI_Subject({
        isEn: lang !== "ar",
        fieldId: ApplicationInformationData?.fieldId,
      })
    );
  }, [lang, ApplicationInformationData?.fieldId]);

  useEffect(() => {
    dispatch(
      setSC_NT_AI_ApplicationInformation({ ...ApplicationInformationData })
    );
  }, [ApplicationInformationData]);
  console.log(state.SC_NT_AI_ApplicationInformation, "SC_ST_AI_SubjectList");

  return (
    <>
      <div className="form-grid" style={{ marginBottom: "0px" }}>
        <AllDropDownsAHSF
          fieldsName="field"
          lang={lang}
          show={true}
          yesNo={true}
          disabled={props.disabled}
          arrayOoptionList={SC_ST_AI_FieldList}
          KeyText={lang !== "ar" ? "fieldNameEn" : "fieldNameAr"}
          value={ApplicationInformationData?.fieldId}
          key={lang}
          hidelable={false}
          valueEdite={ApplicationInformationData?.fieldId}
          submissionStatus={"edite"}
          textEdite={
            lang === "ar"
              ? ApplicationInformationData?.fieldNameAr
              : ApplicationInformationData.fieldNameEn
          }
          id={"fieldId"}
          dropdownType={"search"}
          defaultValue={ApplicationInformationData?.fieldId}
          OnClickLi={(e) => {
            SetApplicationInformationData({
              ...ApplicationInformationData,
              fieldId: e.fieldId,
              subjectId: null,
            });

            setcleartopic(true);
            setEditValue(e.fieldId);
            setEditText(lang === "ar" ? e.fieldNameAr : e.fieldNameEn);
          }}
          showValidationMessage={
            ValiationList?.includes("field") ? true : false
          }
          validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
        />
        <AllDropDownsAHSF
          fieldsName="topic"
          lang={lang}
          show={true}
          yesNo={true}
          clear={cleartopic}
          disabled={props.disabled}
          arrayOoptionList={SC_ST_AI_SubjectList}
          KeyText={lang !== "ar" ? "subjectNameEn" : "subjectNameAr"}
          KeyValue={"subjectId"}
          value={ApplicationInformationData?.subjectId}
          key={lang}
          hidelable={false}
          valueEdite={ApplicationInformationData?.subjectId}
          submissionStatus={"edite"}
          textEdite={
            lang === "ar"
              ? ApplicationInformationData?.subjectNameAr
              : ApplicationInformationData.subjectNameEn
          }
          id={"subjectId"}
          dropdownType={"search"}
          defaultValue={ApplicationInformationData?.subjectId}
          OnClickLi={(e) => {
            setcleartopic(false);

            SetApplicationInformationData({
              ...ApplicationInformationData,
              subjectId: e.subjectId,
            });

            setEditValue(e.subjectId);
            setEditText(lang === "ar" ? e.subjectNameAr : e.subjectNameEn);
          }}
          showValidationMessage={
            ValiationList?.includes("topic") ? true : false
          }
          validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
        />
      </div>
      <div className="form_flexColumn">
        <TextAreaAHSF
          fieldsName="AboutScientificContributionArabic"
          show={true}
          lang={lang}
          dir="rtl"
          type="arabic"
          disabled={props.disabled}
          onChange={(e) => {
            SetApplicationInformationData({
              ...ApplicationInformationData,
              summaryScientificContributionAr: e.target.value,
            });
          }}
          defaultValue={
            ApplicationInformationData?.summaryScientificContributionAr
          }
          showValidationMessage={
            ValiationList?.includes("AboutScientificContributionArabic")
              ? true
              : false
          }
          validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
        />
        <TextAreaAHSF
          fieldsName="AboutScientificContributionEnglish"
          show={true}
          lang={lang}
          dir="ltr"
          type="english"
          disabled={props.disabled}
          onChange={(e) => {
            SetApplicationInformationData({
              ...ApplicationInformationData,
              summaryScientificContributionEn: e.target.value,
            });
          }}
          defaultValue={
            ApplicationInformationData?.summaryScientificContributionEn
          }
          showValidationMessage={
            ValiationList?.includes("AboutScientificContributionEnglish")
              ? true
              : false
          }
          validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
        />
      </div>
    </>
  );
};

export default ApplicationInfo;
